import {IMenuItem} from '../interfaces/IMenuItem';
import {IOptionSet} from '../interfaces/IOptionSet';
import {reconcileOptionSelections, findMissingRequiredOptionSet, findUnavailableRequiredOptionSet} from './optionSetSelection';

export const refreshMenuItemOptions = (item: IMenuItem, sets: Record<string, IOptionSet>, selectDefaults = false): IMenuItem => {
    const optionSets = (item.optionSetIds ?? []).map(id => sets[id] ?? {id, name: 'Required options', isRequired: true, options: []}).filter(set => !set.deleted);
    const selectedOptions = reconcileOptionSelections(optionSets, item.selectedOptions ?? [], selectDefaults);
    return {...item, basePrice: item.basePrice ?? item.price ?? 0, price: item.basePrice ?? item.price ?? 0,
        optionSets, selectedOptions,
        optionAvailabilityChanged: item.optionAvailabilityChanged || selectedOptions.length < (item.selectedOptions ?? []).length};
};

export const getBasketOptionIssue = (item: IMenuItem): string | undefined => {
    if (item.totalInBasket <= 0) return undefined;
    const unavailable = findUnavailableRequiredOptionSet(item.optionSets ?? []);
    if (unavailable) return `${item.name ?? 'This item'} is unavailable: ${unavailable.name ?? 'a required option set'} has no active options. Remove it or wait for availability to return.`;
    if (item.optionAvailabilityChanged) return `Options for ${item.name ?? 'this item'} changed. Review the item and update your basket.`;
    const missing = findMissingRequiredOptionSet(item.optionSets ?? [], item.selectedOptions ?? []);
    if (missing) return `Choose an option for ${missing.name ?? 'the required option set'} on ${item.name ?? 'this item'}.`;
    return undefined;
};
